import React from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';

import WomanLaptopSVG from '~/assets/svgs/woman-laptop.svg';
import { Button, Text } from '~/components';

interface Props {
  visible: boolean;
  onDismiss: () => void;
}

const ConfirmationModal: React.FC<Props> = ({ visible, onDismiss }) => {
  return (
    <Modal
      isVisible={visible}
      onBackdropPress={onDismiss}
      onBackButtonPress={onDismiss}
      className={'items-center justify-center flex-1'}
    >
      <View className="px-10 pb-10 bg-light-100 items-center justify-center">
        <WomanLaptopSVG className="mt-[-100px]" />

        <Text className="text-[22px] mt-5 mb-8 font-medium">Pronto!</Text>

        <Text className="text-gray-400 text-base text-center mb-8">
          Enviei um e-mail para você com um link para alterar sua senha.
        </Text>

        <Button
          onPress={onDismiss}
          variant="secondary"
          className="w-full uppercase"
        >
          Beleza!
        </Button>
      </View>
    </Modal>
  );
};

export default ConfirmationModal;
